@for (market of markets; track market.id) {
    <div class="betbuilder-market">
        <ms-bet-builder-market-card [event]="event" [fixtureId]="fixtureId" [market]="market" [showName]="showName" />
    </div>
}
